import { render } from "./program.vue?vue&type=template&id=21096fe8&scoped=true"
import script from "./program.vue?vue&type=script&lang=js"
export * from "./program.vue?vue&type=script&lang=js"

import "./program.vue?vue&type=style&index=0&id=21096fe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21096fe8"]])

export default __exports__